<template>
<v-container fluid fill-height>
    <loading v-if="loading"></loading>
    <v-layout v-else class="crop-profiles-container">
        <v-flex>
            <v-card>
                <v-layout pa-2>
                    <v-layout column>
                        <v-layout>
                            <v-flex xs12>
                                <h1 class="text-xs-center">Crop Profiles</h1>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 v-if="loadCropError">
                                <v-alert value="loadCropError" outline type="error">
                                    {{this.loadCropError}}
                                </v-alert>
                            </v-flex>
                            <v-flex xs12 v-else class="crop-details">
                                <v-layout>
                                    <v-flex xs6 class="label">
                                        <span>Crop Location</span>
                                    </v-flex>
                                    <v-flex xs6 class="value">
                                        {{this.crop.LocationName}}
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs6 class="label">
                                        <span>Varieties</span>
                                    </v-flex>
                                    <v-flex xs6 class="value">
                                        <div v-for="(cropVariety) in this.crop.CropVarieties" :key="cropVariety.CropVatietyID">
                                            {{cropVariety.ProductVarietyName}}
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <crop-profiles
                            ref="cropProfiles" 
                            :cropLocationID="cropLocationID"
                            :crop="crop">
                        </crop-profiles>
                    </v-layout>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import Loading from '@/components/generic/Loading.vue';
import CropProfiles from '@/components/crops/CropProfiles.vue';
import cropApi from '@/api/cropApi';

export default {
    components: {
        Loading,
        CropProfiles
    },
    data() {
        return {
            loading: false,
            crop: null,
            loadCropError: null
        };
    },
    computed: {
        cropLocationID() {
            return this.$route.params.cropLocationID;
        }
    },
    methods: {
        async init() {            
            try {
                this.loading = true;
                this.loadCropError = null;

                this.crop = await cropApi.getCropByCropLocationID(this.cropLocationID);
            }
            catch (error) {
                this.loadCropError = error;
            }
            finally {
                this.loading = false;
            }
        }
    },
    created() {
        this.init();
    }
}
</script>

<style scoped>
.crop-profiles-container .crop-details .label {
    text-align: right;
    font-weight: bold;
}

.crop-profiles-container .crop-details .value {
    text-align: left;
    padding-left: 10px;
}

.crop-profiles-container .v-alert {
    text-align: center;
}
</style>
